const { h, render, Component } = require('preact');

const TimeInput = ({props}) => (
  <span>
    {I18n.translate('js.modules.support.at')}
    <input class="inputField time_input time_input_us" placeholder="" size="10" maxLength="15" type="text" readonly="readonly" data-bhw='flex_step_three_us_time_input' aria-label="Time"/>
  </span>
);

module.exports = TimeInput
